import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orden-compra',
  templateUrl: './orden-compra.component.html',
  styleUrls: ['./orden-compra.component.css']
})


export class OrdenCompraComponent implements OnInit {
 
  constructor() { }

  ngOnInit(): void {

  }

 
 





}
